const tour = {
  id: 'dashboard-tour',
  steps: [
    {
      title: 'Welcome',
      content: 'Hey there! Let me walk you through how the Dashboard works.',
      target: 'logo',
      placement: 'bottom'
    },
    {
      title: 'Menu',
      content: 'Here are the programs that you have access to.',
      target: 'leftMenu',
      placement: 'right'
    },
    {
      title: 'Search',
      content: 'Too many programs? No worries! You can do a quick search here. You can also bookmark frequently accessed programs!',
      target: 'searchTop',
      placement: 'bottom'
    },
    {
      title: 'Widgets',
      content: 'You can add Wigets to your Dashboard. There are many useful Widgets available. Check them out!',
      target: 'widgetsBtn',
      placement: 'left'
    },
    {
      title: 'Notifications',
      content: 'This is where you check your Notifications.',
      target: 'notificationBtn',
      placement: 'left'
    },
    {
      title: 'User Settings',
      content: 'Change of account settings, password, view report history and more!',
      target: 'userSettingsBtn',
      placement: 'left'
    }
  ]
}

export default tour
